import { selectStpRates } from '@va/aaas/shared/selectors';
import { moduleNames, tabNames } from '@va/constants';
import { isModuleEnabled as isModuleEnabledSelector } from '@va/dashboard/selectors/app';
import { ChatBotIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { getNavIconByName } from '@va/standalone/shared/helpers';
import { getUserRole } from '@va/standalone/shared/selectors';
import { isEcomModuleEnabled } from '@va/util/helpers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useWebsiteStpData = () => {
  const translate = useTranslate();
  const userRole = useSelector(getUserRole);
  const isModuleEnabled = useSelector(isModuleEnabledSelector);

  const {
    stpConsumedVisit,
    stpConsumedVisitEvent,
    stpConsumedSessionRecording,
    stpConsumedHeatmapIncrement,
    stpConsumedEcomEvent,
    stpConsumedAiQuery,
    //tp rate
    stpRateHeatmapIncrement,
    stpRateSessionRecording,
    stpRateVisit,
    stpRateVisitEvent,
    stpRateEcomEvent,
    stpRateAiQuery,
  } = useSelector(selectStpRates);

  const rowLabelBaseKey = 'pageHeader.stpCounter.tp';

  return useMemo(
    () => [
      {
        stpRateLabel: translate(`${rowLabelBaseKey}.rate.visits`),
        stpConsumedLabel: translate(`${rowLabelBaseKey}.visits`),
        stpRate: stpRateVisit,
        stpConsumed: stpConsumedVisit,
        icon: getNavIconByName(tabNames.pageVisits, false, '#fff'),
      },
      {
        stpRateLabel: translate(`${rowLabelBaseKey}.rate.recordings`),
        stpConsumedLabel: translate(`${rowLabelBaseKey}.recordings`),
        stpRate: stpRateSessionRecording,
        stpConsumed: stpConsumedSessionRecording,
        icon: getNavIconByName(tabNames.recordings, false, '#fff'),
        hidden: !isModuleEnabled(moduleNames.sessionRecordings),
      },
      {
        stpRateLabel: translate(`${rowLabelBaseKey}.rate.heatmaps`),
        stpConsumedLabel: translate(`${rowLabelBaseKey}.heatmaps`),
        stpRate: stpRateHeatmapIncrement,
        stpConsumed: stpConsumedHeatmapIncrement,
        icon: getNavIconByName(tabNames.heatmaps, false, '#fff'),
        hidden: !isModuleEnabled(moduleNames.heatmaps),
      },
      // TODO: add back once the credit consumption is implemented for these modules
      // {
      //   stpRateLabel: translate(`${rowLabelBaseKey}.rate.funnels`),
      //   stpConsumedLabel: translate(`${rowLabelBaseKey}.funnels`),
      //   stpRate: stpRateFunnelMatch,
      //   stpConsumed: stpConsumedFunnelMatch,
      //   icon: getNavIconByName(tabNames.funnels, false, '#fff'),
      //   hidden: !isModuleEnabled(moduleNames.funnels),
      // },
      // {
      //   stpRateLabel: translate(`${rowLabelBaseKey}.rate.polls`),
      //   stpConsumedLabel: translate(`${rowLabelBaseKey}.polls`),
      //   stpRate: stpRatePollAnswer,
      //   stpConsumed: stpConsumedPollAnswer,
      //   icon: getNavIconByName(tabNames.polls, false, '#fff'),
      //   hidden: !isModuleEnabled(moduleNames.polls),
      // },
      // {
      //   stpRateLabel: translate(`${rowLabelBaseKey}.rate.surveys`),
      //   stpConsumedLabel: translate(`${rowLabelBaseKey}.surveys`),
      //   stpRate: stpRateSurveyAnswer,
      //   stpConsumed: stpConsumedSurveyAnswer,
      //   icon: getNavIconByName(tabNames.surveys, false, '#fff'),
      //   hidden: !isModuleEnabled(moduleNames.surveys),
      // },
      {
        stpRateLabel: translate(`${rowLabelBaseKey}.rate.events`),
        stpConsumedLabel: translate(`${rowLabelBaseKey}.events`),
        stpRate: stpRateVisitEvent,
        stpConsumed: stpConsumedVisitEvent,
        icon: getNavIconByName(tabNames.eventTracking, false, '#fff'),
        hidden: !isModuleEnabled(moduleNames.eventTracking),
      },
      {
        stpRateLabel: translate(`${rowLabelBaseKey}.rate.ecom`),
        stpConsumedLabel: translate(`${rowLabelBaseKey}.ecom`),
        stpRateLabelTooltip: translate(`${rowLabelBaseKey}.ecomTooltip`),
        stpConsumedLabelTooltip: translate(`${rowLabelBaseKey}.rate.ecomTooltip`),
        stpRate: stpRateEcomEvent,
        stpConsumed: stpConsumedEcomEvent,
        icon: getNavIconByName(tabNames.ecommerce, false, '#fff'),
        hidden: !isEcomModuleEnabled(userRole),
      },
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.aiChatbot`),
        stpConsumedLabelTooltip: translate(`${rowLabelBaseKey}.rate.aiChatbotTooltip`),
        stpRateLabel: translate(`${rowLabelBaseKey}.rate.aiChatbot`),
        stpConsumed: stpConsumedAiQuery,
        stpRate: stpRateAiQuery,
        icon: <ChatBotIcon />,
      },
    ],
    [
      isModuleEnabled,
      stpConsumedAiQuery,
      stpConsumedEcomEvent,
      stpConsumedHeatmapIncrement,
      stpConsumedSessionRecording,
      stpConsumedVisit,
      stpConsumedVisitEvent,
      stpRateAiQuery,
      stpRateEcomEvent,
      stpRateHeatmapIncrement,
      stpRateSessionRecording,
      stpRateVisit,
      stpRateVisitEvent,
      translate,
      userRole,
    ],
  );
};
